class Warehouses {
  constructor({ ...data }) {
    this.Id = data?.Id || '';
    this.Name = data?.Name || '';
  }
}

export default Warehouses;
